import { z } from 'zod';

/**
 * Allergens an ingredient can carry: the FDA's nine major food allergens (FALCPA, plus sesame
 * under the FASTER Act) and pork, which Crave tracks because the kitchen handles it and guests
 * ask. The database mirrors this list in the ingredients_allergens_known check (migration 0019);
 * a test asserts the two are equal.
 */
export const FDA_MAJOR_ALLERGENS = [
  'milk',
  'eggs',
  'fish',
  'crustacean_shellfish',
  'tree_nuts',
  'peanuts',
  'wheat',
  'soybeans',
  'sesame',
] as const;

export const ALLERGENS = [...FDA_MAJOR_ALLERGENS, 'pork'] as const;
export type Allergen = (typeof ALLERGENS)[number];

export const ALLERGEN_LABELS: Record<Allergen, string> = {
  milk: 'Milk',
  eggs: 'Eggs',
  fish: 'Fish',
  crustacean_shellfish: 'Crustacean shellfish',
  tree_nuts: 'Tree nuts',
  peanuts: 'Peanuts',
  wheat: 'Wheat',
  soybeans: 'Soybeans',
  sesame: 'Sesame',
  pork: 'Pork',
};

export const AllergenSchema = z.enum(ALLERGENS);

export function isAllergen(value: string): value is Allergen {
  return (ALLERGENS as readonly string[]).includes(value);
}

/** Known allergens only, de-duplicated, in ALLERGENS order. */
export function sortAllergens(values: Iterable<string>): Allergen[] {
  const present = new Set(values);
  return ALLERGENS.filter((a) => present.has(a));
}
